import { connect } from 'react-redux'
import { MODE_SOLUTION } from '../../../constants';
import { selectAnswer, deselectAnswer } from '../../../actions/exam';
import Question from "./Question";

const mapStateToProps = (state, ownProps) => {
  return {
    selected: state.exam.selected,
    mode: state.exam.mode,
    choices: state.exam.choices[state.exam.currentQuestion || 0],
    showSolution: state.exam.showSolution || state.exam.mode === MODE_SOLUTION,
    showChoices: state.exam.mode === MODE_SOLUTION
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectAnswer: choice => dispatch(selectAnswer(choice)),
    deselectAnswer: choice => dispatch(deselectAnswer(choice))
  };
};

const QuestionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Question);

export default QuestionContainer
